import React from 'react';
import PropTypes from 'prop-types';

import { uniqBy } from 'lodash';

import { connect } from 'react-redux';
import { addActivity } from 'bundles/apex/deals/show/store/activities/actions';

import Modal from 'bundles/apex/activities/modal';
import { buildActivity } from 'bundles/apex/activities/form/helpers';

export function ActivityCreationModal({ addActivity, deal, show, onClose }) {
  return (
    <Modal
      activity={buildActivity(deal.activitiesPath, { availableTagsPath: deal.availableTagsPath })}
      header="Add an activity"
      show={show}
      onHide={onClose}
      onSave={addActivity}
    />
  );
}

ActivityCreationModal.propTypes = {
  addActivity: PropTypes.func.isRequired,
  deal: PropTypes.shape({
    activitiesPath: PropTypes.string.isRequired,
    availableTagsPath: PropTypes.string.isRequired,
  }).isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  addActivity,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityCreationModal);
